module.exports = __webpack_public_path__ + "img/image-15.05cc20e4.png";